import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectCommunitiesQueryItems } from '../../../../../redux/community/selector';
import { communities } from '../../../../../redux/community/action';
import PageLoader from '../../../../../components/PageLoader';
import { MyCommunityComponent } from '../components/community.component';
import { forumPosts } from '../../../../../redux/forum-posts/action';


const MyCommunity = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectCommunitiesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
   const [addItem, setAddItem] = useState<any>(undefined);
     const [selectedTopic, setSelectedTopic] = useState<any>(null);
  const [
    selectedCommunity,
    setSelectedCommunity
  ] = useState<any>([])



  const fetchQueryById = async () => {
    await dispatch(communities.resetAction({ actionType: 'query' }))
 await   dispatch(communities.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/query`, entity: 'communities', jsonData: {

        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {

      if (parmas?.id > 0) {
        fetchQueryById()

      } 

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        const querydata: any = queryItems?.result?.items
        setSelectedCommunity(querydata)
      }
    },
    [isQuery]
  )
  const back = () => {
    navigate('/oneuser/community/mycommunities')
  }
  const closeModal = () => {
    setAddItem(undefined)
    setSelectedTopic('')
  }



  
  const handleSaveItem =async (data:any) =>{

      const forumPostData = {

      "Context": {},
      "Id": 0,
      "TopicId": data?.Id,
      "Text": data?.Text,
      "MediaMappings": {
        "MediaFiles": [],
        "Templates": []

      }
    }

await dispatch(forumPosts.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-posts`,
        entity: 'forumPosts',
        jsonData: {
          Records: [
            forumPostData
          ]
        }
      }))
      await fetchQueryById()
      await closeModal()
  }
if(queryItems?.isLoading){
return (
  <>
  <PageLoader /> 
  </>
)
}

const handleLike = async (postId: number) => {
  await dispatch(forumPosts.create({
    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-post-votes`,
    entity: 'forumPosts',
    jsonData: {
      Records: [
        {
          ForumPostId: postId,
          IsUp: true
        }
      ]
    }
  }));
  await fetchQueryById(); 
};

const handleDislike = async (postId: number) => {
  await dispatch(forumPosts.create({
    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/forum/forum-post-votes`,
    entity: 'forumPosts',
    jsonData: {
      Records: [
        {
          ForumPostId: postId,
          IsUp: false
        }
      ]
    }
  }));
  await fetchQueryById(); 
};

  
  return (
    <>

   
        <MyCommunityComponent
        closeModal={closeModal}
        selectedTopic={selectedTopic}
        setSelectedTopic={setSelectedTopic}
          selectedCommunity={selectedCommunity}
          setAddItem={setAddItem}
          addItem={addItem}
          handleSaveItem={handleSaveItem}
          back={back}
          handleLike = {handleLike}
          handleDislike = {handleDislike}

        />
   
    </>
  )

}

export default MyCommunity;